import Component from '../abstracts/Component';

export default class SizeSelectorComponent extends Component {

  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-sizes-trigger]',
      select: '[data-sizes-select]',
      dropdown: '[data-sizes-dropdown]',
      size: '[data-size]',
      sizeError: '[data-sizes-error]',
      pdpMain: '[data-pdp-main]',
      toBag: '[data-pdp-bag]',
      notify: '[data-pdp-notify]',
      sizeSelected: '[data-size-selected]',
      sizesInfo: '[data-sizes-info]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.clickOutside = this.clickOutside.bind(this);
    this.trigger = this.$component.querySelector(this.SELECTORS.trigger);
    this.sizeSelect = this.$component.querySelector(this.SELECTORS.select);
    this.sizeDropdown = this.$component.querySelector(this.SELECTORS.dropdown);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.size);
    this.sizeError = this.$component.querySelector(this.SELECTORS.sizeError);
    this.mainSelector = this.$component.dataset.main == 'true';
    this.pdpMain = document.querySelector(this.SELECTORS.pdpMain);
    this.toBag = this.pdpMain.querySelector(this.SELECTORS.toBag);
    this.notify = this.pdpMain.querySelector(this.SELECTORS.notify);
    this.selected = this.$component.querySelector(this.SELECTORS.sizeSelected);
    this.box = this.$component;
    this.sizesInfo = this.$component.querySelector(this.SELECTORS.sizesInfo);
  }

  toggleDropdown() {
    this.trigger.classList.toggle('open');
    this.trigger.scrollIntoView({behavior: 'smooth', block: 'center'});
    document.addEventListener('click', this.clickOutside);
    this.sizeDropdown.addEventListener('click', e => e.stopPropagation());
  }

  closeDropdown() {
    this.trigger.classList.remove('open');
    document.removeEventListener('click', this.clickOutside);
  }

  clickOutside(e) {
    if (e.target != this.trigger && e.target != this.sizesInfo) {
      this.closeDropdown();
    }
  }

  selectSize(size) {
    let prevSize = this.sizeDropdown.querySelector('.selected');
    if (prevSize) {
      prevSize.classList.remove('selected');
    }
    size.classList.add('selected');
    this.sizeSelect.value = size.dataset.value;
    this.selected.innerHTML = size.innerHTML;
    this.selected.dataset.unavailable = size.dataset.unavailable;
    this.closeDropdown();
  }

  cleanSelectSize() {
    this.sizes.forEach(size => {
      size.classList.remove('selected');
    });
    // reset value
    if (typeof this.sizeSelect !== 'undefined' && this.sizeSelect != null) {
      this.sizeSelect.value = '';
    }
  }

  bindEvents() {
    let ctx = this;
    //
    this.trigger.addEventListener('click', () => {
      this.toggleDropdown();
    });
    if (this.sizesInfo) {
      this.sizesInfo.addEventListener('click', () => {
        this.toggleDropdown();
      });
    }
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener('click', () => {
          // put size
          this.selectSize(size);
          // if not available launch notify me event
          if (size.dataset.unavailable == 'true') {
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {size: size, box: this.box});
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {size: size, box: this.box});
          }
          // general event
          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {button: size});
          // reset error
          if (this.sizeError) {
            this.sizeError.innerHTML = '';
            this.sizeError.classList.remove('show');
          }
        });
        if (size.dataset.uniqueSize == 'true') {
          this.selectSize(size);
        }
      });
    }

    // on notifymeended reset select
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeended, ({event, payload}) => {
      // reset value
      this.cleanSelectSize();
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      let sizeErrorBoxes = document.querySelectorAll('[data-sizes-error=prod-' + e.payload.dataset.code + ']');
      // put error
      sizeErrorBoxes.forEach(sizeErrorBox => {
        if (sizeErrorBox && !sizeErrorBox.classList.contains('show')) {
          sizeErrorBox.classList.add('show');
          sizeErrorBox.innerHTML = e.payload.attributes['data-notification'].nodeValue;
        }
      });
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
